<template>
  <div class="check-wrap">
    <input type="checkbox" v-model="checked" :id="_uid" :disabled="isDisabled" :name="name" :value="value">
    <label class="check-alt" :for="_uid">{{ inpLabel }}</label>
    <div class="actions-wrap" v-if="showActions_">
      <div class="action"
           v-for="action in actions"
           v-html="actionIcons[action]"
           @click.prevent.stop="onActionClicked($event, action)"
           v-bind:key="action"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    actions: Array,
    inpName: {
      type: String
    },
    isChecked: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    inpLabel: {
      type: String
    },
    name: {
      type: String
    },
    value: [String, Number, Object],
    showActions: Boolean
  },
  watch: {
    showActions: function () {
      this.showActions_ = this.showActions;
    },
    actions: function () {
      this.actions_ = this.actions;
    }
  },
  data: function () {
    return {
      actionIcons: {
        remove: '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path fill-rule="evenodd" clip-rule="evenodd" d="M5.24935 0.583496H8.74935C9.39368 0.583496 9.91602 1.10583 9.91602 1.75016V2.3335H11.666C12.3103 2.3335 12.8327 2.85583 12.8327 3.50016V4.66683C12.8327 5.31116 12.3103 5.8335 11.666 5.8335H11.6192L11.0827 12.25C11.0827 12.8943 10.5603 13.4167 9.916 13.4167H4.08267C3.43833 13.4167 2.916 12.8943 2.91801 12.2984L2.37927 5.8335H2.33268C1.68835 5.8335 1.16602 5.31116 1.16602 4.66683V3.50016C1.16602 2.85583 1.68835 2.3335 2.33268 2.3335H4.08268V1.75016C4.08268 1.10583 4.60502 0.583496 5.24935 0.583496ZM4.08268 3.50016V3.5H2.33266V4.66667H11.666V3.5H9.91602V3.50016H4.08268ZM4.08265 12.2502L3.54977 5.8335H10.4487L9.918 12.2017L9.91599 12.2502H4.08265ZM8.74935 1.75016V2.3335H5.24935V1.75016H8.74935Z" fill="#740B99"/>\n' + '</svg>\n',
        duplicate: '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path fill-rule="evenodd" clip-rule="evenodd" d="M5.83268 1.16699H11.666C12.3382 1.16699 12.8327 1.66149 12.8327 2.33366V8.16699C12.8327 8.83916 12.3382 9.33366 11.666 9.33366H9.33268V11.667C9.33268 12.3392 8.83818 12.8337 8.16602 12.8337H2.33268C1.66052 12.8337 1.16602 12.3392 1.16602 11.667V5.83366C1.16602 5.16149 1.66052 4.66699 2.33268 4.66699H4.66602V2.33366C4.66602 1.66149 5.16052 1.16699 5.83268 1.16699ZM4.66602 5.83366H2.33268V11.667H8.16602V9.33366H5.83268C5.16052 9.33366 4.66602 8.83916 4.66602 8.16699V5.83366ZM5.83268 2.33366V8.16699H11.666V2.33366H5.83268Z" fill="#740B99"/>\n' + '</svg>\n',
        duplicateToAdmin: '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path fill-rule="evenodd" clip-rule="evenodd" d="M5.83268 1.16699H11.666C12.3382 1.16699 12.8327 1.66149 12.8327 2.33366V8.16699C12.8327 8.83916 12.3382 9.33366 11.666 9.33366H9.33268V11.667C9.33268 12.3392 8.83818 12.8337 8.16602 12.8337H2.33268C1.66052 12.8337 1.16602 12.3392 1.16602 11.667V5.83366C1.16602 5.16149 1.66052 4.66699 2.33268 4.66699H4.66602V2.33366C4.66602 1.66149 5.16052 1.16699 5.83268 1.16699ZM4.66602 5.83366H2.33268V11.667H8.16602V9.33366H5.83268C5.16052 9.33366 4.66602 8.83916 4.66602 8.16699V5.83366ZM5.83268 2.33366V8.16699H11.666V2.33366H5.83268Z" fill="#740B99"/>\n' + '</svg>\n',
        edit: '<svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path fill-rule="evenodd" clip-rule="evenodd" d="M0.113048 10.443C0.0742237 10.5711 0.113676 10.7082 0.216159 10.8023C0.280309 10.861 0.362817 10.8972 0.449792 10.9074C0.362851 10.8971 0.280379 10.861 0.216252 10.8023C0.113769 10.7082 0.0743165 10.5711 0.11314 10.443L1.05717 7.31913C1.07572 7.25775 1.11124 7.20186 1.16044 7.15676L8.33925 0.576787C8.72251 0.225493 9.23482 0.0645924 9.73629 0.0940838C9.23479 0.0645671 8.72244 0.225466 8.33915 0.576781L1.16035 7.15676C1.11115 7.20185 1.07563 7.25775 1.05708 7.31912L0.113048 10.443ZM0.146557 10.866C0.0190932 10.749 -0.0300577 10.5783 0.0182772 10.4189L0.96229 7.29505C0.985368 7.21869 1.02958 7.14911 1.0908 7.093L8.2696 0.513023C9.01518 -0.170357 10.2239 -0.170357 10.9695 0.513023L11.4418 0.945881C12.1861 1.62968 12.1861 2.73672 11.4417 3.42052L4.26303 10.0006C4.20181 10.0567 4.12591 10.0973 4.0426 10.1184L0.6344 10.9839C0.460506 11.028 0.274216 10.9828 0.146557 10.866ZM10.3764 3.22634L10.3765 3.22638L10.8032 2.83523C11.1954 2.47491 11.1954 1.89157 10.8032 1.53111L10.3309 1.09832C10.1713 0.952042 9.97142 0.865202 9.76398 0.837788C9.97138 0.865216 10.1712 0.952058 10.3308 1.09832L10.8031 1.5311C11.1953 1.89157 11.1953 2.47491 10.8031 2.83523L10.3764 3.22634ZM10.7335 2.77154C11.0873 2.44644 11.0874 1.9201 10.7335 1.59482L10.2613 1.16207C9.90687 0.83725 9.33223 0.837261 8.97784 1.16209L8.62052 1.48948L10.3764 3.09887L10.7335 2.77154ZM7.91246 2.01119L9.80723 3.74791L3.93182 9.13322L3.93187 9.13326L9.80732 3.74792L7.9125 2.01115L7.91246 2.01119ZM9.66812 3.74791L3.93178 9.00575L2.17622 7.39649L7.91241 2.13865L9.66812 3.74791ZM1.07856 10.0121L3.17243 9.48032L1.65869 8.0927L1.65871 8.09264L3.17253 9.48033L1.07855 10.0121L1.07856 10.0121ZM1.21964 9.88267L1.70836 8.26575L2.98358 9.43472L1.21964 9.88267Z" fill="#740B99"/>\n' + '</svg>\n',
        approve: '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path fill-rule="evenodd" clip-rule="evenodd" d="M5.83268 1.16699H11.666C12.3382 1.16699 12.8327 1.66149 12.8327 2.33366V8.16699C12.8327 8.83916 12.3382 9.33366 11.666 9.33366H9.33268V11.667C9.33268 12.3392 8.83818 12.8337 8.16602 12.8337H2.33268C1.66052 12.8337 1.16602 12.3392 1.16602 11.667V5.83366C1.16602 5.16149 1.66052 4.66699 2.33268 4.66699H4.66602V2.33366C4.66602 1.66149 5.16052 1.16699 5.83268 1.16699ZM4.66602 5.83366H2.33268V11.667H8.16602V9.33366H5.83268C5.16052 9.33366 4.66602 8.83916 4.66602 8.16699V5.83366ZM5.83268 2.33366V8.16699H11.666V2.33366H5.83268Z" fill="#740B99"/>\n' + '</svg>\n'
      },
      showActions_: false,
      actions_: this.actions
    };
  },
  computed: {
    checked: {
      get () {
        return this.isChecked;
      },
      set (value) {
        this.$emit('change', value);
      }
    }
  },
  methods: {
    onActionClicked (event, action) {
      this.$emit('click', action);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/components/checkbox";

.check-wrap {
  position: relative;
}

.show-actions {
  .actions-wrap {
    width: auto;
  }
}

.actions-wrap {
  position: absolute;
  top: -50%;
  left: 30px;
  width: 1700px;
  display: flex;
  justify-content: left;
  align-items: center;
  background-color: #FFFFFF;
  z-index: 100;
}

.action {
  width: 30px;
  height: 30px;
  border: 1px solid #C2CAD8;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 5px;
  position: relative;

  vertical-align: middle;
  margin-left: 10px;
  background-color: #FFFFFF;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.action:hover, .action:active {
  border: 1px solid #740B99 !important;
}
</style>
